module.exports = __webpack_public_path__ + "img/stadistics.f4c0f235.png";